module.exports = __webpack_public_path__ + "img/red.a0939045.svg";